import { ComponentProps } from 'react';
import { useTranslation } from '@frontend/i18n';
import { AlignCenterIconSmall, AlignLeftIconSmall, AlignRightIconSmall, RadioField } from '@frontend/design-system';
import { FrameAlignment } from '../types';
import { Setting } from './setting';
import { getRadioOptionStyles, radioFieldStyles } from './styles';

type Props = ComponentProps<typeof RadioField> & {
  value: FrameAlignment;
};

export const AlignmentSetting = (props: Props) => {
  const { t } = useTranslation('content-composer');

  return (
    <Setting title={t('Layout')}>
      <RadioField {...props} css={radioFieldStyles}>
        <RadioField.Radio value='left' className='hide-radio' css={getRadioOptionStyles(props.value === 'left')}>
          <AlignLeftIconSmall />
        </RadioField.Radio>
        <RadioField.Radio value='center' className='hide-radio' css={getRadioOptionStyles(props.value === 'center')}>
          <AlignCenterIconSmall />
        </RadioField.Radio>
        <RadioField.Radio value='right' className='hide-radio' css={getRadioOptionStyles(props.value === 'right')}>
          <AlignRightIconSmall />
        </RadioField.Radio>
      </RadioField>
    </Setting>
  );
};
